// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorLoader_error__2C2bM"};